<template>
  <div>
    <div class="row">
      <div class="col-xl-9">
        <b-card no-body>
          <b-table
            id="itemTable"
            striped
            sort-icon-left
            show-empty
            empty-text="There are no matching items to show"
            :items="this.itemsInType()"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
          >
            <template v-slot:head(selected)>
              <b-form-checkbox v-model="itemsCheck" @change="checkAll"
                >Select all</b-form-checkbox
              >
            </template>
            <template v-slot:head(name)>
              {{ nameLabel }}
            </template>
            <template v-slot:head(subcategory)>
              {{ subcategoryLabel }}
            </template>
            <template v-slot:head(category)>
              {{ categoryLabel }}
            </template>
            <template v-slot:head(children)>
              {{ buttonSubcategoryLabel }}
            </template>
            <template v-slot:head(sItems)> Active items </template>
            <template v-slot:cell(selected)="{ item }">
              <b-form-checkbox
                size="lg"
                :value="item"
                v-model="selectedItems"
                @change="itemCheck"
              />
            </template>
            <template v-slot:cell(image)="{ item }">
              <img :src="getImage(item)" width="100px" />
            </template>
            <template v-slot:cell(name)="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:cell(step)="{ item }">
              {{ item.step.name }}
            </template>
            <template v-slot:cell(required)="{ item }">
              {{ item.amount }} {{ item.item.unit }}
            </template>
            <template v-slot:cell(source)="{ item }">
              {{ item.source }}
            </template>
            <template v-slot:cell(stages)="{ item }">
              {{ item.stages.length }}
            </template>
            <template v-slot:cell(actions)="{ item }">
              <input-button
                type="button"
                label="View details"
                class="btn-yellow"
                @click="viewItem(item)"
              />
              <input-button
                type="button"
                label="Export"
                class="btn-dark text-yellow"
                @click="exportShow(item)"
              />
            </template>
          </b-table>
        </b-card>
      </div>
      <div class="col-xl-3">
        <div>
          <div role="tablist">
            <b-card no-body class="p-0">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.tab1 variant="light"
                  >Filters</b-button
                >
              </b-card-header>
              <b-collapse id="tab1" visible role="tabpanel">
                <b-card-body>
                  <label class="width-full"
                    ><b>Search:</b>
                    <input
                      v-model="search"
                      placeholder="Search item"
                      type="search"
                      class="form-control"
                    />
                  </label>
                  <label
                    class="width-full"
                    v-if="
                      $route.params.level == 'step' ||
                      $route.params.level == 'stage'
                    "
                    ><b>Storyboard:</b>
                    <select
                      v-model="storyboardFilter"
                      class="form-control"
                      @change="stageFilter = 'all'"
                    >
                      <option value="all" selected>All</option>
                      <option
                        v-for="sb in $parent.$parent
                          .filterEventStoryboards(activeEvent.id)
                          .sort((a, b) => (a.name > b.name ? 1 : -1))"
                        :key="sb.id"
                        :value="sb.id"
                      >
                        {{ sb.name }}
                      </option>
                    </select>
                  </label>
                  <label class="width-full" v-if="$route.params.level == 'step'"
                    ><b>Stage:</b>
                    <select v-model="stageFilter" class="form-control">
                      <option value="all" selected>All</option>
                      <option
                        v-for="stage in $parent.$parent
                          .filterEventStages(activeEvent.id, storyboardFilter)
                          .sort((a, b) => (a.name > b.name ? 1 : -1))"
                        :key="stage.id"
                        :value="stage.id"
                      >
                        {{ stage.name }}
                      </option>
                    </select>
                  </label>
                  <div v-if="contentIs4S">
                    <label
                      class="width-full"
                      v-if="categoryLevel == 'subcategory'"
                    >
                      <b>{{ categoryFilterLabel }}</b>
                      <select v-model="categoryFilter" class="form-control">
                        <option value="all" selected>All</option>
                        <option
                          v-for="category in this.parentCategories()"
                          :key="category.id"
                          :value="category.id"
                        >
                          {{ category.name }}
                        </option>
                      </select>
                    </label>
                    <div v-if="categoryLevel == 'item'">
                      <label class="width-full">
                        <b>Uncategorized items:</b>
                        <b-form-checkbox switch v-model="onlyUncategorizedItems"
                          >Only uncategorized items</b-form-checkbox
                        >
                      </label>
                      <label class="width-full">
                        <b>{{ categoryFilterLabel }}</b>
                        <select
                          v-model="itemCategoryFilter"
                          class="form-control"
                          @change="subcategoryFilter = 'all'"
                        >
                          <option value="all" selected>All</option>
                          <option
                            v-for="category in this.parentCategories()"
                            :key="category.id"
                            :value="category.id"
                          >
                            {{ category.name }}
                          </option>
                        </select>
                      </label>
                      <label class="width-full">
                        <b>{{ subcategoryFilterLabel }}</b>
                        <select
                          v-model="subcategoryFilter"
                          class="form-control"
                        >
                          <option value="all" selected>All</option>
                          <option
                            v-for="category in this.subcategories()"
                            :key="category.id"
                            :value="category.id"
                          >
                            {{ category.name }}
                          </option>
                        </select>
                      </label>
                      <label class="width-full"
                        ><b>Source:</b>
                        <select v-model="source" class="form-control">
                          <option value="All" selected>All</option>
                          <option value="None">None</option>
                          <option value="Owned">Owned</option>
                          <option value="Contract">Contract</option>
                          <option value="Other">Other</option>
                        </select>
                      </label>
                      <label class="width-full"
                        ><b>Planning status:</b>
                        <select v-model="status" class="form-control">
                          <option value="all" selected>All</option>
                          <option value="true">In use</option>
                          <option value="false">Inactive</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <input-button
                    type="button"
                    @click="resetFilters"
                    label="Reset filters"
                    class="btn-yellow mt-2"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="p-0">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.tab2 variant="light"
                  >Selected Items</b-button
                >
              </b-card-header>
              <b-collapse id="tab2" visible role="tabpanel">
                <b-card-body>
                  <b-card-text>
                    <p v-if="!selectedItems.length">No items selected.</p>
                    <ul>
                      <li
                        class="mb-2"
                        v-for="(selectedItem, index) in selectedItems"
                        :key="selectedItem.id"
                      >
                        {{
                          selectedItem.name
                            ? selectedItem.name
                            : selectedItem.item.name
                        }}
                        <b-button
                          v-b-tooltip.left="'Unselect item'"
                          class="
                            btn btn-danger btn-icon btn-circle btn-sm
                            pull-right
                          "
                          @click="unselect(index)"
                        >
                          <i class="fa fa-times" />
                        </b-button>
                      </li>
                    </ul>
                  </b-card-text>
                  <div v-if="selectedItems.length">
                    <label class="width-full"
                      ><b>Action:</b>
                      <select v-model="action" class="form-control">
                        <option value="view">View all</option>
                        <option value="export">Export</option>
                      </select>
                    </label>
                    <b-button @click="selectAction" class="btn-yellow"
                      >Select</b-button
                    >
                    <input-button
                      type="button"
                      @click="unselectAll"
                      label="Unselect all"
                      class="btn-danger pull-right"
                    />
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-t-10">
      <div class="col-6">
        <label
          ><b>Per page</b>
          <b-form-select v-model="perPage" :options="perPageOptions" />
        </label>
      </div>
      <b-pagination
        class="col-6 pagination"
        next-class="{ background-color: red; }"
        align="right"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="itemTable"
      />
    </div>

    <!-- start item modal -->
    <b-modal
      ref="modalViewAll"
      size="xl"
      centered
      :title="modalTitle"
      class="row"
      @hidden="index = 0"
      hide-footer
    >
      <div class="col-12">
        <div v-if="currentItem">
          <!-- start step modal content -->
          <task-step-modal-content
            :categories="categories"
            :items="items"
            :currentItem="currentItem"
            :filterStepScriptItems="$parent.$parent.filterStepScriptItems"
            :getTypeName="$parent.$parent.getTypeName"
            :setItemTitle="setItemTitle"
            v-if="$route.params.level == 'step'"
          />
          <!-- end step modal content -->
          <!-- start stage modal content -->
          <task-stage-modal-content
            :categories="categories"
            :items="items"
            :currentItem="currentItem"
            :filterStepScriptItems="$parent.$parent.filterStepScriptItems"
            :getTypeName="$parent.$parent.getTypeName"
            :setItemTitle="setItemTitle"
            :getItemActiveItems="getItemActiveItems"
            v-else-if="$route.params.level == 'stage'"
          />
          <!-- end stage modal content -->
          <!-- start storyboard modal content -->
          <task-storyboard-modal-content
            :categories="categories"
            :items="items"
            :currentItem="currentItem"
            :filterStepScriptItems="$parent.$parent.filterStepScriptItems"
            :getTypeName="$parent.$parent.getTypeName"
            :setItemTitle="setItemTitle"
            :getItemActiveItems="getItemActiveItems"
            :storyboardSteps="getItemSteps(currentItem)"
            :storyboardStages="$parent.$parent.getStoryboardStages(currentItem)"
            v-else-if="$route.params.level == 'storyboard'"
          />
          <!-- end storyboard modal content -->
          <!-- start 4S modal content -->
          <task-script-category-modal-content
            :categories="categories"
            :items="items"
            :currentItem="currentItem"
            :filterCategorySteps="filterCategorySteps"
            :filterCategoryScriptItems="filterCategoryScriptItems"
            :buttonSubcategoryLabel="buttonSubcategoryLabel"
            :categoryParent="categoryParent(currentItem)"
            :subcategoryLabel="subcategoryLabel"
            :categoryLabel="categoryLabel"
            :getFullItem="getFullItem"
            :getItemStoryboard="getItemStoryboard"
            :getItemStage="getItemStage"
            v-else-if="contentIs4S && categoryLevel != 'item'"
          />
          <task-script-modal-content
            :categories="categories"
            :scriptItems="filterItemScriptItems(currentItem)"
            :currentItem="currentItem"
            :getFullItem="getFullItem"
            :getFullIStep="getFullIStep"
            :getItemStoryboard="getItemStoryboard"
            :getItemStage="getItemStage"
            :categoryParent="categoryParent"
            :subcategoryLabel="subcategoryLabel"
            :categoryLabel="categoryLabel"
            v-else-if="contentIs4S && categoryLevel == 'item'"
          />
          <!-- end 4S modal content -->
          <b-card
            class="m-b-20"
            header-tag="header"
            header-bg-variant="dark"
            header-text-variant="light"
          >
            <template v-slot:header>
              <h6 class="mb-0">Actions</h6>
            </template>
            <input-button
              type="button"
              label="Export"
              class="btn-dark text-yellow pull-right"
              @click="exportShow(currentItem)"
            />
          </b-card>
        </div>
        <b-card
          v-if="selectedItems.length > 1"
          bg-variant="dark"
          text-variant="light"
        >
          <b-row>
            <b-col>
              <button
                @click="previousItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg"
              >
                <i class="fa fa-chevron-left" />
              </button>
            </b-col>
            <b-col class="text-center">
              <!--<b-list-group horizontal>
                                <b-list-group-item class="text-center" button @click="toItem(index)" v-for="(selectedItem, index) in selectedItems" :key="selectedItem.id">{{ selectedItem.name }}</b-list-group-item>
                            </b-list-group>-->
              <h2>{{ index + 1 }} / {{ selectedItems.length }}</h2>
            </b-col>
            <b-col>
              <button
                @click="nextItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg pull-right"
              >
                <i class="fa fa-chevron-right" />
              </button>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>
    <!-- end item modal -->

    <!-- start export modal -->
    <b-modal
      ref="modalExport"
      centered
      title="Export"
      ok-title="Export"
      ok-variant="yellow"
      @ok="itemsExport()"
      @hidden="emptyExportItems()"
      cancel-variant="white"
    >
      <label class="width-full" v-if="exportItem">
        <b>Item to export:</b>
        <h5>{{ exportItem.item ? exportItem.item.name : exportItem.name }}</h5>
      </label>
      <label class="width-full" v-if="exportItems.length">
        <b>Items to export:</b>
        <b-list-group>
          <b-list-group-item
            class="text-center"
            v-for="exportItem in exportItems"
            :key="exportItem.id"
          >
            {{ exportItem.item ? exportItem.item.name : exportItem.name }}
          </b-list-group-item>
        </b-list-group>
      </label>
      <label class="width-full">
        <b>Export as:</b>
        <select v-model="exportMethod" class="form-control">
          <option value="pdf" selected>PDF</option>
          <option value="xls" selected>Excel</option>
        </select>
      </label>
    </b-modal>
    <!-- end export modal -->
  </div>
</template>

<script>
import InputButton from '../buttons/InputButton.vue'
import TaskStepModalContent from '../task/TaskStepModalContent.vue'
import TaskStageModalContent from '../task/TaskStageModalContent.vue'
import TaskStoryboardModalContent from '../task/TaskStoryboardModalContent.vue'
import TaskScriptCategoryModalContent from '../task/TaskScriptCategoryModalContent.vue'
import TaskScriptModalContent from '../task/TaskScriptModalContent.vue'
import { taskService } from '../../services/task.service.js'

export default {
  name: 'TaskItemTable',
  props: [
    'filteredItems',
    'items',
    'categories',
    'steps',
    'scriptItems',
    'activeEvent',
    'contentIs4S',
    'categoryLevel',
    'filterCategorySteps',
    'filterCategoryScriptItems'
  ],
  components: {
    InputButton,
    TaskStepModalContent,
    TaskStageModalContent,
    TaskStoryboardModalContent,
    TaskScriptCategoryModalContent,
    TaskScriptModalContent
  },
  data() {
    return {
      nameLabel: 'Name',
      subcategoryLabel: 'Area',
      categoryLabel: 'Venue',
      buttonSubcategoryLabel: 'Areas',
      buttonCategoryLabel: 'Venues',
      itemsCheck: false,
      servicesCheck: false,
      spacesCheck: false,
      staffCheck: false,
      stuffCheck: false,
      selectedItems: [],
      storyboardFilter: 'all',
      stageFilter: 'all',
      categoryFilter: 'all',
      subcategoryFilter: 'all',
      itemCategoryFilter: 'all',
      categoryFilterLabel: 'Venue:',
      subcategoryFilterLabel: 'Area:',
      source: 'All',
      status: 'all',
      search: '',
      onlyUncategorizedItems: false,
      action: 'view',
      modalTitle: '',
      modal: false,
      index: 0,
      currentItem: null,
      categoryId: 0,
      perPageOptions: [5, 10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      fields: [],
      categoryFields: [
        { key: 'selected', sortable: false },
        { key: 'image', sortable: false },
        { key: 'name', sortable: true },
        {
          key: 'children',
          sortable: true,
          formatter: (value) => {
            return value.length
          },
          sortByFormatted: true
        },
        {
          key: 'activeItems',
          sortable: true,
          formatter: (value, key, item) => {
            return this.getItemActiveItems(item)
          },
          sortByFormatted: true
        },
        {
          key: 'steps',
          label: 'Active Steps',
          sortable: true,
          formatter: (value, key, item) => {
            return this.getItemSteps(item).length
          },
          sortByFormatted: true
        },
        { key: 'actions', sortable: false }
      ],
      subCategoryFields: [
        { key: 'selected', sortable: false },
        { key: 'image', sortable: false },
        { key: 'name', sortable: true },
        {
          key: 'category',
          sortable: true,
          formatter: (value, key, item) => {
            return this.categoryParent(item)
          },
          sortByFormatted: true
        },
        {
          key: 'activeItems',
          sortable: true,
          formatter: (value, key, item) => {
            return this.getItemActiveItems(item)
          },
          sortByFormatted: true
        },
        {
          key: 'steps',
          label: 'Active Steps',
          sortable: true,
          formatter: (value, key, item) => {
            return this.getItemSteps(item).length
          },
          sortByFormatted: true
        },
        { key: 'actions', sortable: false }
      ],
      itemFields: [
        { key: 'selected', sortable: false },
        { key: 'image', sortable: false },
        { key: 'name', sortable: true },
        {
          key: 'sItems',
          sortable: true,
          formatter: (value, key, item) => {
            return item.scriptItems.length
          },
          sortByFormatted: true
        },
        {
          key: 'subcategory',
          sortable: true,
          formatter: (value, key, item) => {
            return item.category ? item.category.name : '-'
          },
          sortByFormatted: true
        },
        {
          key: 'category',
          sortable: true,
          formatter: (value, key, item) => {
            return this.categoryParent(item)
          },
          sortByFormatted: true
        },
        { key: 'source', sortable: true },
        {
          key: 'total',
          sortable: true,
          formatter: (value, key, item) => {
            return `${item.amount} ${item.unit}`
          },
          sortByFormatted: true
        },
        { key: 'actions', sortable: false }
      ],
      exportItem: null,
      exportItems: [],
      exportMethod: 'pdf'
    }
  },
  computed: {
    rows() {
      return this.itemsInType().length
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    getFields() {
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            {
              key: 'stage',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemStage(item)
              },
              sortByFormatted: true
            },
            {
              key: 'storyboard',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemStoryboard(item)
              },
              sortByFormatted: true
            },
            {
              key: 'activeItems',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemActiveItems(item)
              },
              sortByFormatted: true
            },
            { key: 'actions', sortable: false }
          ]
          break
        case 'stage':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            {
              key: 'storyboard',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemStoryboard(item)
              },
              sortByFormatted: true
            },
            {
              key: 'steps',
              label: 'Steps',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemSteps(item).length
              },
              sortByFormatted: true
            },
            {
              key: 'activeItems',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemActiveItems(item)
              },
              sortByFormatted: true
            },
            { key: 'actions', sortable: false }
          ]
          break
        case 'storyboard':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            { key: 'stages.length', label: 'Stages', sortable: true },
            {
              key: 'steps',
              label: 'Steps',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemSteps(item).length
              },
              sortByFormatted: true
            },
            {
              key: 'activeItems',
              sortable: true,
              formatter: (value, key, item) => {
                return this.getItemActiveItems(item)
              },
              sortByFormatted: true
            },
            { key: 'actions', sortable: false }
          ]
          break
        case 'space':
          this.fields = this.fields.length ? this.fields : this.categoryFields
          break
        case 'service':
          this.fields = this.fields.length ? this.fields : this.categoryFields
          break
        case 'staff':
          this.fields = this.fields.length ? this.fields : this.categoryFields
          break
        case 'stuff':
          this.fields = this.fields.length ? this.fields : this.categoryFields
          break
        default:
          break
      }
    },
    getImage(item) {
      if (item.image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return (
          process.env.VUE_APP_API_URL + '/uploads/images/' + item.image.imageFd
        )
      }
    },
    getFullItem(itemId) {
      let fullItem = null
      this.items.forEach((item) => {
        if (item.id == itemId) {
          fullItem = item
        }
      })
      return fullItem
    },
    getFullIStep(stepId) {
      let fullStep = null
      this.steps.forEach((step) => {
        if (step.id == stepId) {
          fullStep = step
        }
      })
      return fullStep
    },
    getItemName(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'space':
          return item.item.name
        case 'service':
          return item.item.name
        case 'staff':
          return item.item.name
        case 'stuff':
          return item.item.name
        default:
          return item.name
      }
    },
    getUsage(currentItemId) {
      let usageString = 'Not in use.'
      this.scriptItems.forEach((scriptItem) => {
        if (scriptItem.amount > 0 && currentItemId == scriptItem.item.id) {
          if (usageString == 'Not in use.') {
            usageString = scriptItem.amount + ' in ' + scriptItem.step.name
          } else {
            usageString +=
              ', ' + scriptItem.amount + ' in ' + scriptItem.step.name
          }
        }
      })
      return usageString
    },
    fileType(path) {
      return path.slice(path.lastIndexOf('.') + 1)
    },
    itemsInType() {
      let self = this
      let items = this.filteredItems
      let level = this.$route.params.level
      return items.filter(function (item) {
        switch (level) {
          case 'step':
            return self.filterStep(self, item)
          case 'stage':
            return self.filterStage(self, item)
          case 'storyboard':
            return self.filterStoryboard(self, item)
          case 'space':
            if (self.categoryLevel == 'item') {
              return self.filterTypeItems(self, item)
            } else {
              return self.filterTypeCategories(self, item)
            }
          case 'service':
            if (self.categoryLevel == 'item') {
              return self.filterTypeItems(self, item)
            } else {
              return self.filterTypeCategories(self, item)
            }
          case 'staff':
            if (self.categoryLevel == 'item') {
              return self.filterTypeItems(self, item)
            } else {
              return self.filterTypeCategories(self, item)
            }
          case 'stuff':
            if (self.categoryLevel == 'item') {
              return self.filterTypeItems(self, item)
            } else {
              return self.filterTypeCategories(self, item)
            }
          default:
            break
        }
      })
    },
    filterStep(self, item) {
      var itemStoryboard = self.$parent.$parent.getStoryboard(item.stage)
      if (
        itemStoryboard.id == self.storyboardFilter ||
        self.storyboardFilter == 'all'
      ) {
        var itemStage = self.$parent.$parent.getStage(item.stage)
        if (itemStage.id == self.stageFilter || self.stageFilter == 'all') {
          if (self.search) {
            if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
              return item
            }
          } else {
            return item
          }
        }
      }
    },
    filterStage(self, item) {
      if (
        item.storyboard == self.storyboardFilter ||
        self.storyboardFilter == 'all'
      ) {
        if (self.search) {
          if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
            return item
          }
        } else {
          return item
        }
      }
    },
    filterStoryboard(self, item) {
      if (self.search) {
        if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
          return item
        }
      } else {
        return item
      }
    },
    filterTypeItems(self, item) {
      let level = this.$route.params.level
      let typeId = 1
      switch (level) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          break
      }
      if (item.type.id == typeId && item.scriptItems.length) {
        if (item.category == null) {
          if (self.itemCategoryFilter == 'all') {
            if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
              return item
            }
          }
        } else if (
          !self.onlyUncategorizedItems &&
          (item.category.parent == self.itemCategoryFilter ||
            self.itemCategoryFilter == 'all')
        ) {
          if (
            item.category.id == self.subcategoryFilter ||
            self.subcategoryFilter == 'all'
          ) {
            if (item.source == self.source || self.source == 'All') {
              let sItem = self.scriptItems.find(
                (scriptItem) => scriptItem.item.id == item.id
              )
              if (sItem && sItem.amount > 0 && self.status == 'true') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              } else if (sItem == null && self.status == 'false') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              } else if (self.status == 'all') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              }
            }
          }
        }
      }
    },
    filterTypeCategories(self, item) {
      let level = this.$route.params.level
      let typeId = 1
      switch (level) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          break
      }
      if (
        (this.categoryLevel == 'category' && !item.parent) ||
        (this.categoryLevel == 'subcategory' && item.parent)
      ) {
        if (
          this.categoryFilter == 'all' ||
          this.categoryFilter == item.parent.id
        ) {
          if (item.type.id == typeId) {
            if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
              return item
            }
          }
        }
      }
    },
    filterItemScriptItems(item) {
      return this.scriptItems.filter((sItem) => {
        return sItem.item.id == item.id
      })
    },
    onLevelSwitch() {
      switch (this.categoryLevel) {
        case 'category':
          this.fields = this.categoryFields
          break
        case 'subcategory':
          this.fields = this.subCategoryFields
          break
        case 'item':
          this.fields = this.itemFields
          break
        default:
          break
      }
      this.unselectAll()
      this.resetFilters()
      this.emptyExportItems()
    },
    getItemStage(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          return this.$parent.$parent.getStage(item.stage).name
        case 'stage':
          break
        case 'storyboard':
          break
        case 'service':
          return this.$parent.$parent.getStage(item.stage)
        case 'space':
          return this.$parent.$parent.getStage(item.stage)
        case 'staff':
          return this.$parent.$parent.getStage(item.stage)
        case 'stuff':
          return this.$parent.$parent.getStage(item.stage)
        default:
          return this.$parent.$parent.getStage(item.stage).name
      }
    },
    getItemStoryboard(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          return this.$parent.$parent.getStoryboard(item.stage).name
        case 'stage':
          return this.$parent.$parent.getStoryboard(item.id).name
        case 'storyboard':
          break
        case 'service':
          return this.$parent.$parent.getStoryboard(item.stage)
        case 'space':
          return this.$parent.$parent.getStoryboard(item.stage)
        case 'staff':
          return this.$parent.$parent.getStoryboard(item.stage)
        case 'stuff':
          return this.$parent.$parent.getStoryboard(item.stage)
        default:
          return this.$parent.$parent.getStoryboard(item.stage).name
      }
    },
    getItemActiveItems(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          return this.$parent.$parent.filterStepScriptItems(item).length
        case 'stage':
          return this.$parent.$parent.filterStageScriptItems(item).length
        case 'storyboard':
          if (item.stages && item.stages.length) {
            return this.$parent.$parent.filterStoryboardScriptItems(item).length
          } else if (item.storyboard && item.steps && item.steps.length) {
            return this.$parent.$parent.filterStageScriptItems(item).length
          } else {
            return 0
          }
        case 'service':
          return this.$parent.$parent.filterCategoryScriptItems(item).length
        case 'space':
          return this.$parent.$parent.filterCategoryScriptItems(item).length
        case 'staff':
          return this.$parent.$parent.filterCategoryScriptItems(item).length
        case 'stuff':
          return this.$parent.$parent.filterCategoryScriptItems(item).length
        default:
          return 0
      }
    },
    getItemSteps(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'stage':
          return item.steps
        case 'storyboard':
          return this.$parent.$parent.getStoryboardSteps(item)
        case 'service':
          return this.filterCategorySteps(item)
        case 'space':
          return this.filterCategorySteps(item)
        case 'staff':
          return this.filterCategorySteps(item)
        case 'stuff':
          return this.filterCategorySteps(item)
        default:
          break
      }
    },
    parentCategories() {
      let matchingCategories = []
      let type = this.$route.params.level
      let typeId = 1
      switch (type) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          typeId = 1
          break
      }
      this.categories.filter(function (category) {
        if (category.type.id == typeId && !category.parent) {
          matchingCategories.push(category)
        }
      })
      return matchingCategories
    },
    subcategories(isChanging) {
      let subcategoriesInMainCategories = []
      let subcategoriesInType = []
      let parentCategory = this.itemCategoryFilter
      if (parentCategory != 'all') {
        this.categories.forEach((category) => {
          if (category.parent) {
            if (category.parent.id == parentCategory) {
              subcategoriesInMainCategories.push(category)
            }
          }
        })
        return subcategoriesInMainCategories
      } else if (isChanging || parentCategory == 'all') {
        let type = this.$route.params.type
        let typeId = 1
        switch (type) {
          case 'service':
            typeId = 1
            break
          case 'space':
            typeId = 2
            break
          case 'staff':
            typeId = 3
            break
          case 'stuff':
            typeId = 4
            break
          default:
            typeId = 1
            break
        }
        this.categories.forEach((category) => {
          if (category.type.id == typeId) {
            if (category.parent) {
              subcategoriesInType.push(category)
            }
          }
        })
        return subcategoriesInType
      }
    },
    categoryName(currentCategory) {
      if (currentCategory) {
        let categoryName = ''
        this.categories.forEach((category) => {
          if (category.id == currentCategory) {
            categoryName = category.name
          }
        })
        return categoryName
      } else {
        return ''
      }
    },
    categoryParent(item) {
      switch (this.categoryLevel) {
        case 'subcategory':
          return item.parent ? item.parent.name : '-'
        case 'item':
          if (item.category) {
            let parentName = ''
            this.categories.forEach((category) => {
              if (category.id == item.category.parent) {
                parentName = category.name
              }
            })
            return parentName
          } else {
            return '-'
          }
        default:
          return '-'
      }
    },
    updateLabels() {
      let level = this.$route.params.level
      switch (level) {
        case 'service':
          switch (this.categoryLevel) {
            case 'category':
              this.nameLabel = 'Manage Categories'
              break
            case 'subcategory':
              this.nameLabel = 'Manage Areas'
              break
            case 'item':
              this.nameLabel = 'Manage Items'
              break
            default:
              break
          }
          this.buttonSubcategoryLabel = 'Areas'
          this.buttonCategoryLabel = 'Categories'
          this.subcategoryLabel = 'Area'
          this.categoryLabel = 'Category'
          this.categoryFilterLabel = 'Category:'
          this.subcategoryFilterLabel = 'Area:'
          this.modalTitle = 'Service category items'
          break
        case 'space':
          switch (this.categoryLevel) {
            case 'category':
              this.nameLabel = 'Manage Venues'
              break
            case 'subcategory':
              this.nameLabel = 'Manage Areas'
              break
            case 'item':
              this.nameLabel = 'Manage Items'
              break
            default:
              break
          }
          this.buttonSubcategoryLabel = 'Areas'
          this.buttonCategoryLabel = 'Venues'
          this.subcategoryLabel = 'Area'
          this.categoryLabel = 'Venue'
          this.categoryFilterLabel = 'Venue:'
          this.subcategoryFilterLabel = 'Area:'
          this.modalTitle = 'Space category items'
          break
        case 'staff':
          switch (this.categoryLevel) {
            case 'category':
              this.nameLabel = 'Manage Groups'
              break
            case 'subcategory':
              this.nameLabel = 'Manage Teams'
              break
            case 'item':
              this.nameLabel = 'Manage Items'
              break
            default:
              break
          }
          this.buttonSubcategoryLabel = 'Teams'
          this.buttonCategoryLabel = 'Groups'
          this.subcategoryLabel = 'Team'
          this.categoryLabel = 'Group'
          this.categoryFilterLabel = 'Group:'
          this.subcategoryFilterLabel = 'Team:'
          this.modalTitle = 'Staff category items'
          break
        case 'stuff':
          switch (this.categoryLevel) {
            case 'category':
              this.nameLabel = 'Manage Categories'
              break
            case 'subcategory':
              this.nameLabel = 'Manage Subcategories'
              break
            case 'item':
              this.nameLabel = 'Manage Items'
              break
            default:
              break
          }
          this.buttonSubcategoryLabel = 'Subcategories'
          this.buttonCategoryLabel = 'Categories'
          this.subcategoryLabel = 'Subcategory'
          this.categoryLabel = 'Main category'
          this.categoryFilterLabel = 'Main category:'
          this.subcategoryFilterLabel = 'Subcategory:'
          this.modalTitle = 'Stuff category items'
          break
        case 'storyboard':
          this.nameLabel = 'Organize Storyboard'
          this.modalTitle = 'Storyboard'
          break
        case 'stage':
          this.nameLabel = 'Organize Stage'
          this.modalTitle = 'Stage'
          break
        case 'step':
          this.nameLabel = 'Organize Step'
          this.modalTitle = 'Step'
          break
        default:
          this.nameLabel = 'Name'
          break
      }
    },
    checkUsage(currentItemId) {
      let amountInUse = 0
      this.scriptItems.forEach((scriptItem) => {
        if (currentItemId == scriptItem.item.id) {
          amountInUse += scriptItem.amount
        }
      })
      return amountInUse
    },
    resetFilters() {
      this.search = ''
      this.storyboardFilter = 'all'
      this.stageFilter = 'all'
      this.onlyUncategorizedItems = false
      this.itemCategoryFilter = 'all'
      this.categoryFilter = 'all'
      this.subcategoryFilter = 'all'
      this.source = 'All'
      this.status = 'all'
    },
    selectAction() {
      switch (this.action) {
        case 'view':
          this.currentItem = this.selectedItems[0]
          this.$refs['modalViewAll'].show()
          break
        case 'export':
          this.exportMultiple()
          break
        default:
          break
      }
    },
    checkAll(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    itemCheck(checked) {
      if (!checked) {
        this.itemsCheck = false
      }
    },
    unselect(index) {
      this.itemsCheck = false
      this.selectedItems.splice(index, 1)
    },
    unselectAll() {
      this.selectedItems = []
      this.itemsCheck = false
      this.servicesCheck = false
      this.spacesCheck = false
      this.staffCheck = false
      this.stuffCheck = false
    },
    previousItem() {
      if (this.index == 0) {
        this.index = this.selectedItems.length - 1
      } else {
        this.index--
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    nextItem() {
      if (this.index == this.selectedItems.length - 1) {
        this.index = 0
      } else {
        this.index++
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    /*toItem(index) {
            this.showItemById(this.selectedItems[index].id);
            this.index = index;
        },*/
    showItemById(itemId) {
      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.id == itemId) {
          this.currentItem = selectedItem
        }
      })
    },
    setItemTitle(item) {
      if (item.stage) {
        var stage = this.$parent.$parent.getStage(item.stage)
        var storyboard = this.$parent.$parent.getStoryboard(item.stage)
        return `${item.name} < ${stage.name} < ${storyboard.name}`
      }
    },
    closeModal() {
      this.$refs['modalViewAll'].hide()
    },
    viewItem(item) {
      this.selectedItems = []
      this.itemsCheck = false
      this.currentItem = item
      this.$refs['modalViewAll'].show()
    },
    exportShow(item) {
      this.exportItem = item
      this.$refs['modalExport'].show()
    },
    exportMultiple() {
      this.exportItems = this.selectedItems
      this.$refs['modalExport'].show()
    },
    emptyExportItems() {
      this.exportItem = null
      this.exportItems = []
    },
    itemsExport() {
      switch (this.exportMethod) {
        case 'pdf':
          this.exportAsPDF()
          break
        case 'xls':
          this.exportAsXls()
          break
        default:
          break
      }
    },
    exportAsPDF() {
      let exportType = ''
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          exportType = 'step'
          break
        case 'stage':
          exportType = 'stage'
          break
        case 'storyboard':
          exportType = 'storyboard'
          break
        case 'service':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'space':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'staff':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'stuff':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        default:
          break
      }
      let exportItemIds = []
      if (this.exportItem) {
        exportItemIds.push(this.exportItem.id)
      } else if (this.exportItems.length) {
        this.exportItems.forEach((eItem) => {
          exportItemIds.push(eItem.id)
        })
      }
      taskService.exportPdf(
        JSON.stringify({
          type: exportType,
          items: exportItemIds,
          eventId: parseInt(this.activeEvent.id)
        })
      )
    },
    exportAsXls() {
      let exportType = ''
      let level = this.$route.params.level
      switch (level) {
        case 'step':
          exportType = 'step'
          break
        case 'stage':
          exportType = 'stage'
          break
        case 'storyboard':
          exportType = 'storyboard'
          break
        case 'service':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'space':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'staff':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        case 'stuff':
          if (this.categoryLevel == 'item') {
            exportType = 'item'
          } else {
            exportType = 'category'
          }
          break
        default:
          break
      }
      let exportItemIds = []
      if (this.exportItem) {
        exportItemIds.push(this.exportItem.id)
      } else if (this.exportItems.length) {
        this.exportItems.forEach((eItem) => {
          exportItemIds.push(eItem.id)
        })
      }
      taskService.exportXls(
        JSON.stringify({
          type: exportType,
          items: exportItemIds,
          eventId: parseInt(this.activeEvent.id)
        })
      )
    }
  },
  watch: {
    $route() {
      this.resetFilters()
      this.updateLabels()
      this.getFields()
      this.unselectAll()
      this.currentItem = null
      this.emptyExportItems()
    },
    categoryLevel() {
      this.onLevelSwitch()
      this.updateLabels()
      this.currentItem = null
    }
  },
  mounted() {
    this.updateLabels()
    this.getFields()
  }
}
</script>
